
class StringUtil {

  static checkEmail(str) {
    var reg_email = /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
    return reg_email.test(str);
  }

  static checkOnlyEngAndNum(str) {
    console.log("str:::", str);
    return /^[a-z0-9]+$/.test(str);
  }

}

export default StringUtil;
